import * as THREE from 'three';

// Remap Mixamo bone names: "mixamorig:Hips" → "mixamorigHips"
export const remapMixamoClip = (clip, targetRoot) => {
    const boneNames = new Set();
    targetRoot.traverse(obj => boneNames.add(obj.name));
    const tracks = clip.tracks.map(track => {
        const dot  = track.name.lastIndexOf('.');
        const bone = track.name.substring(0, dot);
        const prop = track.name.substring(dot);
        if (boneNames.has(bone)) return track;
        const noColon    = bone.replace(/^mixamorig:/i, 'mixamorig');
        if (boneNames.has(noColon))    { const t = track.clone(); t.name = noColon    + prop; return t; }
        const withPrefix = 'mixamorig' + bone;
        if (boneNames.has(withPrefix)) { const t = track.clone(); t.name = withPrefix + prop; return t; }
        return track;
    });
    return new THREE.AnimationClip(clip.name, clip.duration, tracks);
};

export const findHipsBone = (model) => {
    let found = null;
    model.traverse(obj => { if (!found && obj.isBone && /hips/i.test(obj.name)) found = obj; });
    return found;
};
